module.exports = __webpack_public_path__ + "static/img/2.302b51b8.gif";